import type { GuideFeatureDef } from "./features";

export function GuideIcon({ tint }: { tint: GuideFeatureDef["tint"] }) {
  const common = {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    "aria-hidden": true as const,
  };
  if (tint === "send") {
    return (
      <svg {...common}>
        <path d="M4 12h16M13 5l7 7-7 7" />
      </svg>
    );
  }
  if (tint === "archive") {
    return (
      <svg {...common}>
        <path d="M4 7h16v12H4zM8 7V5h8v2" />
      </svg>
    );
  }
  if (tint === "hash") {
    return (
      <svg {...common}>
        <path d="M5 9h14M5 15h14M9 5l-1 14M16 5l-1 14" />
      </svg>
    );
  }
  if (tint === "credit") {
    return (
      <svg {...common}>
        <path d="M12 5v14M5 12h14" />
      </svg>
    );
  }
  if (tint === "num") {
    return (
      <svg {...common}>
        <path d="M7 7h4v10H7zM15 7h2v10h-2" />
      </svg>
    );
  }
  if (tint === "legal") {
    return (
      <svg {...common}>
        <path d="M6 4h12v16H6zM9 8h6M9 12h6M9 16h4" />
      </svg>
    );
  }
  if (tint === "portal") {
    return (
      <svg {...common}>
        <circle cx="12" cy="12" r="8" />
        <path d="M3 12h18M12 4c2.5 2.8 3.8 5.6 3.8 8S14.5 17.2 12 20c-2.5-2.8-3.8-5.6-3.8-8S9.5 6.8 12 4z" />
      </svg>
    );
  }
  if (tint === "sign") {
    return (
      <svg {...common}>
        <path d="M4 18c2-4 5-7 8-8l6-6 2 2-6 6c-1 3-4 6-8 6z" />
      </svg>
    );
  }
  if (tint === "recurring") {
    return (
      <svg {...common}>
        <path d="M4 12a8 8 0 0 1 13-5l2-2v6h-6l2-2a6 6 0 1 0 1 6" />
      </svg>
    );
  }
  if (tint === "mail") {
    return (
      <svg {...common}>
        <path d="M4 7h16v10H4zM4 7l8 6 8-6" />
      </svg>
    );
  }
  if (tint === "docs") {
    return (
      <svg {...common}>
        <path d="M7 4h7l4 4v12H7zM14 4v4h4" />
      </svg>
    );
  }
  if (tint === "team") {
    return (
      <svg {...common}>
        <circle cx="9" cy="8" r="2.4" />
        <circle cx="16" cy="9" r="2" />
        <path d="M4 18c.6-3 2.6-4.5 5-4.5S13.4 15 14 18M13 14.2c1.5-.4 3.1.2 4 1.8" />
      </svg>
    );
  }
  if (tint === "pay") {
    return (
      <svg {...common}>
        <rect x="3" y="6" width="18" height="12" rx="2" />
        <path d="M3 10h18M7 14h4" />
      </svg>
    );
  }
  if (tint === "backup") {
    return (
      <svg {...common}>
        <path d="M4 14a6 6 0 0 1 10.4-4A4.5 4.5 0 1 1 18 18H6.5A3.5 3.5 0 0 1 4 14z" />
      </svg>
    );
  }
  return (
    <svg {...common}>
      <rect x="5" y="11" width="14" height="9" rx="1.5" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" />
    </svg>
  );
}
